import { render, staticRenderFns } from "./side-nav.vue?vue&type=template&id=7fb286b0&scoped=true"
import script from "./side-nav.ts?vue&type=script&lang=ts&external"
export * from "./side-nav.ts?vue&type=script&lang=ts&external"
import style0 from "./side-nav.vue?vue&type=style&index=0&id=7fb286b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb286b0",
  null
  
)

export default component.exports